
import {alertController} from '@ionic/vue';

export default {
    install: (app) => {

        const alert = function(error, title = '') {

            if (!(error.response && error.response.data) && typeof error !== 'string') {
                return;
            }

            let message = '';

            if (typeof error === 'string') {
                message = error;
            }


            if (!message && ! (error.response && error.response.data.errors) ) {
                message = error.response.data.message;
            } else if (!message) {
                const errors = error.response.data.errors
                const messages = [] ;
                const fields = Object.keys(errors);
                for (const field in fields) {
                    messages.push(errors[fields[field]][0]);
                }
                message = messages.join("<br >");
            }

            return alertController.create({
                header: title?title:'Processing Error',
                message: message,
                buttons: ['OK'],
                cssClass: 'wide'
            }).then(alert => {
                return alert.present();
            })
        }

        app.provide('$validationAlert', alert);
    }
}
